import { CoreIcon } from '../core-icon';
import shareSVG from '../../assets/icons/share.svg';
import type { IconProps } from '../core-icon';

export const ShareIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={shareSVG} {...props} />;
};
